const trimTrailingSlash = (value: string | undefined | null) => {
  if (!value) return "";
  return value.endsWith("/") ? value.replace(/\/+$/, "") : value;
};

const DEFAULT_CHAT_SERVER_BASE = "http://localhost:8083";
const DEFAULT_CORE_API_BASE = "http://localhost:8081";

const parseBooleanFlag = (value: string | undefined | null, defaultValue: boolean) => {
  if (value == null) {
    return defaultValue;
  }

  const normalized = value.trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(normalized)) {
    return true;
  }

  if (["0", "false", "no", "off"].includes(normalized)) {
    return false;
  }

  return defaultValue;
};

const chatServerBase =
  trimTrailingSlash(import.meta.env.VITE_CHAT_SERVER_URL) || DEFAULT_CHAT_SERVER_BASE;
const coreApiBase =
  trimTrailingSlash(import.meta.env.VITE_API_BASE_URL) || DEFAULT_CORE_API_BASE;

export const CHAT_API_BASE_URL = trimTrailingSlash(
  import.meta.env.VITE_CHAT_API_URL ?? (chatServerBase ? `${chatServerBase}/api/chat` : "/api/chat")
);

export const CHAT_SOCKET_URL = trimTrailingSlash(
  import.meta.env.VITE_CHAT_SOCKET_URL ??
    (chatServerBase ? `${chatServerBase}/websocket/tracker` : "/websocket/tracker")
);

export const CHAT_APP_DESTINATION = "/app/telemedicine/chat";
export const CHAT_TOPIC_PREFIX = "/topic/telemedicine/chat";

export const CHAT_FEATURE_ENABLED = parseBooleanFlag(
  import.meta.env.VITE_ENABLE_TELEMEDICINE_CHAT,
  false
);

export const CHAT_TOKEN_ENDPOINT = trimTrailingSlash(
  import.meta.env.VITE_CHAT_TOKEN_URL ??
    (coreApiBase
      ? `${coreApiBase}/api/telemedicine/appointments/get-chat-token`
      : "/api/telemedicine/appointments/get-chat-token")
);

export const CHAT_PROVIDER_SEARCH_ENDPOINT = trimTrailingSlash(
  import.meta.env.VITE_CHAT_PROVIDER_SEARCH_URL ??
    (coreApiBase ? `${coreApiBase}/api/provider/search` : "/api/provider/search")
);
